import React from 'react'
import { isMobile } from 'react-device-detect'

const MobileScreen = React.lazy(() => import('./screens/Mobile'));
const PcScreen = React.lazy(() => import('./screens/Pc'));

export default function App() {
  return isMobile ? <MobileScreen /> : <PcScreen />;
}
